// extracted by mini-css-extract-plugin
export default {"container":"SidebarSlider_container__yfbZ0","input":"SidebarSlider_input__umMf+","inputAdornment":"SidebarSlider_inputAdornment__bzcn+","slider":"SidebarSlider_slider__BgfQ9"};